import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addInterpreter } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/interpreterSlice';
import toast from 'react-hot-toast';
import { updateInterpreter } from 'slices/interpreterSlice';
import { fetchInterpreters } from 'slices/interpreterSlice';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import PhoneInput from 'components/common/PhoneInput';
import InterpreterRate from 'components/locations/InterpreterRate';

const apiService = new Api();

const AddInterpreterForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch()
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, setError: setErrors } = useForm({
    defaultValues: {
      name: "",
      email: "",
      password: "",
      // password_confirmation: "",
      address: "",
      zip_code: "",
      after_hour_end_time: "",
      after_hour_start_time: "",
      email: "",
      first_name: "",
      grace_period: "",
      incremental: "",
      inperson_after_mins: "",
      inperson_after_mins_time_unit: "",
      inperson_after_rate: "",
      inperson_after_time_unit: "",
      inperson_normal_mins: "",
      inperson_normal_mins_time_unit: "",
      inperson_normal_rate: "",
      inperson_normal_time_unit: "",
      last_name: "",
      name: "",
      normal_hour_end_time: "",
      normal_hour_start_time: "",
      opi_after_mins: "",
      opi_after_mins_time_unit: "",
      opi_after_rate: "",
      opi_after_rate_time_unit: "",
      opi_normal_mins: "",
      opi_normal_mins_time_unit: "",
      opi_normal_rate: "",
      opi_normal_rate_time_unit: "",
      password: "",
      // password_confirmation: "",
      phone: "",
      status: "",
      vri_after_mins: "",
      vri_after_mins_time_unit: "",
      vri_after_rate: "",
      vri_after_rate_time_unit: "",
      vri_normal_mins: "",
      vri_normal_mins_time_unit: "",
      vri_normal_rate: "",
      vri_normal_rate_time_unit: "",
      zip_code: "",


    }
  });
  const { error, loader } = useSelector(interpreterSelector);
  const [status, setStatus] = useState(1);


  const clearAll = () => {
    setValue("name", '');
    setValue("email");
    setValue('password', '');
    // setValue('password_confirmation', '');
    setValue("phone", '');
    setValue('address', '')
    setValue("zip_code", "");
    setStatus(1)
    dispatch(setError({}))
  }

  useEffect(() => {
    setValue('name', item?.name || '');
    setValue('email', item?.user?.email || '')
    setValue('phone', item?.phone || '');
    setValue('address', item?.address || '')
    setValue('zip_code', item?.zip_code || '');
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    return () => clearAll()

  }, [item]);


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchInterpreters())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    const errors = {};
    if (!data?.vri_normal_mins) {
      errors.vri_normal_mins = "VRI Before Min. Duration is required"
      // setErrors("vri_normal_mins", {
      //   message: "VRI Before Min. Duration is required",
      //   type:"required"
      // })
      // return
    }
    if (!data?.vri_normal_rate) {
      errors.vri_normal_rate = "VRI Before Rate is required"
      // setErrors("vri_normal_rate", {
      //   message: "VRI Before Rate is required",
      //   type:"required"
      // })
      // return
    }
    if (!data?.vri_after_mins) {
      errors.vri_after_mins = "VRI After Min. Duration is required"
      // setErrors("vri_after_mins", {
      //   message: "VRI After Min. Duration is required",
      //   type:"required"
      // })
      // return
    }
    if (!data?.vri_after_rate) {
      errors.vri_after_rate = "VRI After Rate is required"
      // setErrors("vri_after_rate", {
      //   message: "VRI After Rate is required",
      //   type:"required"
      // })
      // return
    }

    if (Object.keys(errors)?.length > 0) {


      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          const error = errors[key];
          if (error) {
            setErrors(key, {
              message: error
            })
          }

        }
      }

      return

    }

    data = {
      ...data,
      status,
    };

    if (item?.id) {
      dispatch(updateInterpreter(data, item?.id, submitCallback));
    } else
      dispatch(addInterpreter(data, submitCallback));

  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="foam_page_row">
          <div className="row-primary row_secondary">
            <h2>Name *</h2>
            <Controller
              name="name"
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' required {...field} />}
            />
          </div>

          <div className="row-primary row_secondary">
            <h2>Email *</h2>
            <div className="w-100">
              <Controller
                name="email"
                control={control}

                render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email' required
                  pattern={
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                  }
                  placeholder="Email Address"
                  {...field}
                />}
              />
              {error?.errors?.email?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>

          <div className="row-primary row_secondary">
            <h2>Password {item?.id ? "" : "*"}</h2>
            <div className="w-100">
              <input className="input-in type_inp" type="password" {...register("password")} name='password' placeholder="Password" required={item?.id ? false : true} />
              {error?.errors?.password?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>

          {/* <div className="row-primary row_secondary">
            <h2>Confirm Password {item?.id ? "" : "*"}</h2>
            <div style={{ width: "100%" }}>
              <input className="input-in type_inp" type="password"
                {...register("password_confirmation", {
                  validate: (value) =>
                    value === watch("password") || "Passwords do not match",
                })}
                name='password_confirmation'
                required={item?.id ? false : true}
                placeholder="Confirm Password" />

              {errors?.password_confirmation &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.password_confirmation?.message} />
                </div>
              }
              {error?.errors?.password_confirmation?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div> */}

          <div className="row-primary row_secondary">
            <h2>Phone Number *</h2>
            <div className="w-100">
              <Controller
                name="phone"
                control={control}
                render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' required {...field} />}
              />
              {error?.errors?.phone?.map((error) => (
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}
            </div>
          </div>

          <div className="row-primary row_secondary">
            <h2>Address</h2>
            <Controller
              name="address"
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />}
            />
          </div>

          <div className="row-primary row_secondary">
            <h2>Zip Code *</h2>
            <div className='w-100'>
              <Controller
                name="zip_code"
                rules={{
                  required: "Please select a City"
                }}
                control={control}
                render={({ field }) =>
                  <input className="input-in type_inp" type="text" name='billing_zipcode' placeholder="Zip Code"
                    {...field}
                  />
                }
              />
              {errors?.billing_zipcode?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.billing_zipcode?.message} />
                </div>
              }


              {error?.errors?.billing_zipcode?.map((error) => (
                <div style={{ marginTop: 10 }}>
                  <ErrorMessage text={error} />
                </div>
              ))}

            </div>
          </div>
        </div>

        <InterpreterRate control={control} error={error} errors={errors} item={item} dispatch={dispatch} setValue={setValue} watch={watch} isClient={false} />

        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status == 1 ? true : false}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        }


        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />
        </div>
      </form>
    </div>
  )
}

const AddInterpreter = ({ item, onClose, callback, show, statusPerm }) => {

  const closeButton = useRef(null)
  const refModal = useRef(null)
  const handleModalDismiss = () => {
    closeButton.current.click()
    onClose()
  };
  useEffect(() => {


    const modalElement = refModal.current;

    if (modalElement) {
      // Attach the event listener
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }

    return () => {
      if (modalElement) {
        // Clean up the event listener
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);

  return (
    <div className={`modal fade`} ref={refModal} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Interpreter</h5>
            <button onClick={handleModalDismiss} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButton}></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddInterpreterForm item={item} handleClose={handleModalDismiss} callback={callback} show={show} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddInterpreter
